import { loanLockDeskSettingsApi } from 'app/services/api';

import { FeatureFlag } from 'constants/featureFlags';
import {
  LOAN_APPLICATION_ACTION_NAME_PREFIX,
  LockExtensionsRequestType,
} from 'constants/loanApplication';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

import { selectFeatureFlagByKey } from 'store/global/selectors';

export const LOCK_INFO_ACTION_TYPE = createNamedActions(
  // LOAN_APPLICATION_ACTION_NAME_PREFIX is used for Redux Middleware in Loan Editor
  `${LOAN_APPLICATION_ACTION_NAME_PREFIX}/lockInfo`,
  {
    GET_LOCK_EXTENSION_SETTINGS: 'GET_LOCK_EXTENSION_SETTINGS',
  },
);

export const getLockExtensionSettingsAction = catchAsyncActionError(
  params => async (dispatch, getState) => {
    const state = getState();
    const isExternalLoanLockEnabled = selectFeatureFlagByKey(FeatureFlag.EnableExternalLoanLock)(
      state,
    );

    const { data } = isExternalLoanLockEnabled
      ? await loanLockDeskSettingsApi.getSettingsV2(params)
      : await loanLockDeskSettingsApi.getSettings(params);

    const type = LOCK_INFO_ACTION_TYPE.GET_LOCK_EXTENSION_SETTINGS;

    if (isExternalLoanLockEnabled) {
      return dispatch({
        type,
        payload: data.type === LockExtensionsRequestType.LENDER ? data.settings : data,
      });
    }

    return dispatch({
      type,
      payload: data,
    });
  },
);
